/**
 * Re-export so stories can import reduced-motion from shared hooks.
 * Implementation lives in duet-ui; this gives a single @hooks entry point.
 */
export { useReducedMotion } from "@voxmedia/duet-ui/hooks/use-reduced-motion";
